import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent, type Analytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Firebase配置
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// 初始化Firebase
const app = initializeApp(firebaseConfig);

// 导出服务
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const functions = getFunctions(app);

export default app;

let analyticsSingleton: Promise<Analytics | null> | null = null;

const canUseAnalytics = typeof window !== 'undefined' && Boolean(firebaseConfig.measurementId);

const ensureAnalytics = () => {
  if (!canUseAnalytics) {
    return Promise.resolve(null);
  }

  if (!analyticsSingleton) {
    analyticsSingleton = isSupported()
      .then((supported) => (supported ? getAnalytics(app) : null))
      .catch((error) => {
        if (import.meta.env.MODE !== 'production') {
          console.warn('[firebase] analytics unavailable', error);
        }
        return null;
      });
  }

  return analyticsSingleton;
};

export const logAnalyticsEvent = async (
  eventName: string,
  eventParams?: Record<string, unknown>
) => {
  const analytics = await ensureAnalytics();
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
};
